import React from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FroalaEditorComponent from "../components/Editor";
import { CustomModal } from "./CustomeModal";

interface ProblemStatementModalProps {
  open: boolean;
  onClose: () => void;
  problemStatement: string;
  onChange: (content: string) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  isPublished: boolean;
}

export const ProblemStatementModal: React.FC<ProblemStatementModalProps> = ({
  open,
  onClose,
  problemStatement,
  onChange,
  onSubmit,
  isSubmitting,
  isPublished,
}) => {
  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title={isPublished ? "View Problem Statement" : "Edit Problem Statement"}
    >
      <FroalaEditorComponent
        value={problemStatement}
        onChange={onChange}
        placeholder="Enter the problem statement..."
        height="55vh"
        isPublished={isPublished}
        readonly={isPublished}
      />
      <Box justifyContent="flex-end" display="flex">
        <Button
          variant="outlined"
          color="primary"
          onClick={onSubmit}
          disabled={isPublished || isSubmitting}
          sx={{ mt: 2 }}
        >
          {isSubmitting ? "Saving..." : "Submit"}
        </Button>
      </Box>
    </CustomModal>
  );
};
